module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/profile/profile.component.css
// module id = ./src/app/components/profile/profile.component.css
// module chunks = main